
import React from 'react';

import './Footer.css';

const Footer = () => {
	return (
		<footer id='footer'>
			<div className="footer-end">
				All  Right Is Reserved 2022 &copy;
			</div>
		</footer>
	);
};

export default Footer;